import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/list-duck";
import { Transport } from "interfaces/transport";

const { Types, Creators } = createActions(
  {
    request: ["query", "onSuccess"],
    success: ["data"],
    failure: ["error"],
    reset: [],
  },
  { prefix: "LIST_TRANSPORTS_" }
);

export interface ListTransportsState extends IState {
  data: Transport[];
}

interface ISuccessListUnitsAction extends ISuccessAction {
  data: Transport[];
}

const INITIAL_STATE: ListTransportsState = {
  data: [],
  loading: false,
  error: null,
};

const request = (state: ListTransportsState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: ListTransportsState, action: ISuccessListUnitsAction) =>
  update(state, {
    data: { $set: action.data },
    loading: { $set: false },
  });

const failure = (state: ListTransportsState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const listTransports = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const ListTransportsTypes = Types;
export const ListTransportsActions = Creators;
